import { FunctionalComponent } from 'preact'
import GenericHeroContent from './GenericHeroContent'
import classnames from 'classnames'
import { GenericHeroConfig } from './index.sync'

interface GenericHeroProps extends SearchScope, GenericHeroConfig {
  centered?: boolean
}

const GenericHeroContainer: FunctionalComponent<GenericHeroProps> = ({
  centered,
  heroImage,
  title,
  subtitle,
  isFederatedSalesforceSearch,
  isFederatedSkilljarSearch,
  isFederatedFreshdeskSearch
}) => {
  const backgroundImageStyle = heroImage && `background-image: url(${heroImage})`

  if (centered) {
    return (
      <div className={classnames('brand-hero', 'qa-brand-hero', 'custom-hero-banner')} style={backgroundImageStyle}>
        <GenericHeroContent
          centered
          title={title}
          subtitle={subtitle}
          isFederatedSalesforceSearch={isFederatedSalesforceSearch}
          isFederatedSkilljarSearch={isFederatedSkilljarSearch}
          isFederatedFreshdeskSearch={isFederatedFreshdeskSearch}
        />
      </div>
    )
  }

  return (
    <div className='forum-featured-image' style={`background-color: transparent;${backgroundImageStyle}`}>
      <div className='forum-featured-image__content brand-hero'>
        <div className='sitewidth'>
          <div className={classnames('col', 'col--main', 'has--side')}>
            <GenericHeroContent
              title={title}
              subtitle={subtitle}
              isFederatedSalesforceSearch={isFederatedSalesforceSearch}
              isFederatedSkilljarSearch={isFederatedSkilljarSearch}
              isFederatedFreshdeskSearch={isFederatedFreshdeskSearch}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default GenericHeroContainer
